module.exports = __webpack_public_path__ + "static/media/qbo.8aea596b.png";